module.exports = __webpack_public_path__ + "assets-cabinet/img/gb.022522ed.svg";